import { useEffect, useState } from "react";

/**
 * True below Tailwind's `sm` breakpoint (640px).
 *
 * Use this — rather than rendering both layouts and toggling with
 * `hidden`/`sm:block` — wherever the phone and desktop versions of a component
 * have genuinely different structure. Two reasons:
 *
 *  - A hidden subtree still mounts. Anything in it that observes layout
 *    (IntersectionObserver, ResizeObserver) never fires, so the hidden copy
 *    silently misbehaves — that is how the channel list would end up
 *    permanently EPG-less on the one viewport that needs it.
 *  - For the mini-player, mounting twice would mean two <video> elements and
 *    two upstream connections. This box's providers allow one stream slot per
 *    account, so a duplicate is not a performance nit — it kills playback.
 */
export function useIsPhone(): boolean {
  const [isPhone, setIsPhone] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(max-width: 639px)").matches,
  );
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)");
    const onChange = (e: MediaQueryListEvent) => setIsPhone(e.matches);
    mq.addEventListener("change", onChange);
    setIsPhone(mq.matches);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isPhone;
}
